import React,{useEffect,useRef} from 'react';

const SHAPO_SCRIPT_ID='shapo-embed-js';
const SHAPO_WIDGET_ID='shapo-widget-502b68781bcc221368fc';
const SHAPO_SCRIPT_SRC='https://cdn.shapo.io/js/embed.js';

const Reviews=()=> {
  const widgetRef=useRef(null);

  useEffect(()=> {
    const widget=widgetRef.current;

    if (!widget) return undefined;

    widget.innerHTML='';

    const script=document.createElement('script');
    script.id=SHAPO_SCRIPT_ID;
    script.type='text/javascript';
    script.src=SHAPO_SCRIPT_SRC;
    script.defer=true;

    widget.appendChild(script);

    return ()=> {
      script.remove();
    };
  },[]);

  return (
    <section id="reviews" className="bg-white py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">
            Our Happy Customers
          </h2>
        </div>

        <div
          ref={widgetRef}
          id={SHAPO_WIDGET_ID}
        />
      </div>
    </section>
  );
};

export default Reviews;